import { combineReducers } from "redux";

import listPermissionReducer from './listPermission'

const permissionReducer = combineReducers({
    listPermissionReducer
})

export default permissionReducer;